import { render, staticRenderFns } from "./partList.vue?vue&type=template&id=a3aaa1de"
import script from "./partList.vue?vue&type=script&lang=js"
export * from "./partList.vue?vue&type=script&lang=js"
import style0 from "./partList.vue?vue&type=style&index=0&id=a3aaa1de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports